import KeyFigurePreset from "./KeyFigurePreset.js";

/**
 * A special system Preset that contain all user visible KeyFigures.
 *
 * NOTE: This presets is a system preset and not visible for the user.
 */
const VisibleKeyFigures = class VisibleKeyFigures extends KeyFigurePreset {
	constructor(spec) {
		super(spec);
		this._id = "VisibleKeyFigures";
		this._name = "Visible KeyFigures";
	}

	/**
	 * Answers true if user can see Preset in UI
	 *
	 * @param {Preset} preset - KeyFigure preset
	 * @return {boolean}
	 */
	isPresetUserVisible(preset) {
		// Exclude this 'Visible Preset'
		if (preset === this) {
			return false;
		}

		// If the preset contains one or many custom keyfigures, then it is user
		// visible as custom keyfigures are always visible.
		if (preset.getKeyFigures().find((kpi) => kpi.isCustom())) {
			return true;
		}

		// Exclude presets without visible KeyFigures
		if (!preset.containsKeyFiguresFrom(this)) {
			return false;
		}

		// Exclude presets mark as invisible on the server side
		return preset.isVisible();
	}

	isVisibleKeyFigures() {
		return true;
	}

	isKeyFigureVisible(keyFigure) {
		return this.containsKeyFigure(keyFigure);
	}
};

export default new VisibleKeyFigures();
